module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8gwJAU/tc-custom/9781453239759.jpg?1733107194099",
      "alt": "This image is the cover for the book Midas Murders, The Pieter Van In Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midas Murders, The Pieter Van In Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the second novel by the international bestselling Pieter Aspe, Inspector Van In races against the clock to thwart a series of terrorist plots"), _c('br')]), _c('br'), _vm._v("One quiet snow-covered Sunday morning in Bruges, a prominent business executive is found dead in the streets, apparently due to an alcoholic hemorrhage, but for Inspector Van In, there is something about the autopsy that does not add up. When he questions the businessman’s friend, a Dutchman, he too is found dead the next morning, burned to death in a house fire."), _c('br'), _c('br'), _vm._v("When there is an explosion in the middle of a popular tourist area in downtown Bruges, Van In strives to find the connection between the three incidents, but no one is coming forward to claim responsibility for this terrorist attack. Just an anonymous letter to the police, threatening more bombings—unless they cooperate with a series of demands that would undermine the entire city government. "), _c('br'), _c('br'), _vm._v("Aided by the spunky and beautiful assistant DA, Hannelore Martens, Inspector Van In finds himself enmeshed in the case that threatens not just the lives of countless innocent people, but the heart of the city he loves."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pieter Aspe, Brian Doyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pieter Aspe is the author of the Pieter Van In mystery series. Aspe lives in Bruges, Belgium, and is one of the most popular contemporary writers in the Flemish language. His novels have sold over one million copies in Europe alone.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0